var render = function render(){var _vm=this,_c=_vm._self._c;return _c('AppLayout',{staticClass:"p-design",attrs:{"slug":"design","icon":"icons","name":"设计资源","has-right":_vm.hasRight},scopedSlots:_vm._u([{key:"left",fn:function(){return [_c('Nav')]},proxy:true},{key:"right",fn:function(){return [_c('favVue')]},proxy:true}])},[_c('div',{staticClass:"m-archive-box"},[_c('router-view')],1)])
}
var staticRenderFns = []

export { render, staticRenderFns }